import React from "react";
import { FiCopy, FiShare2, FiCamera } from "react-icons/fi";

const referredUsers = [
  { name: "Mike Ross", date: "Joined on July 5th, 2024" },
  { name: "Augustus Waters", date: "Joined on July 5th, 2024" },
  { name: "Hazel Grace", date: "Joined on July 5th, 2024" },
  { name: "Julia Anna", date: "Joined on July 5th, 2024" },
  { name: "Jayden Brown", date: "Joined on July 5th, 2024" },
];

const ReferPage = () => {
  return (
    <div className="refer-page-wrapper" style={{marginTop:"115px", marginBottom:"50px"}}>
      <div className="refer-container">
        {/* LEFT SECTION */}
        <div className="refer-left col-xl-10 card border-0">
            <div className="refer-header text-center">Refer a Friend</div>
  <h2 className="refer-title">
    Invite friends & earn <br />
    <span>4 Years</span> of Garshys Membership
  </h2>

  {/* Steps */}
  <div className="refer-steps">
    <div className="step">
      <img
        src="https://cdn-icons-png.flaticon.com/512/747/747376.png"
        alt="Invite"
      />
      <p>Invite a friend</p>
    </div>

    <span className="arrow">→</span>

    <div className="step">
      <img
        src="https://cdn-icons-png.flaticon.com/512/2922/2922510.png"
        alt="Register"
      />
      <p>Friend registers</p>
    </div>

    <span className="arrow">→</span>

    <div className="step">
      <img
        src="https://cdn-icons-png.flaticon.com/512/3135/3135706.png"
        alt="Reward"
      />
      <p>You get 4 years free</p>
    </div>
  </div>

  {/* Progress */}
  <div className="progress-wrapper">
    {[1, 2, 3, 4, 5].map((num) => (
      <div
        key={num}
        className={`progress-circle ${num <= 2 ? "active" : ""}`}
      >
        {num <= 2 ? "✓" : num}
      </div>
    ))}
  </div>



  {/* Referral Link Input */}
<div className="refer-link-box">
  <input
    type="text"
    value="https://garshya.com/ref/PRAJWAL123"
    readOnly
  />
  <button
    onClick={() => {
      navigator.clipboard.writeText(
        "https://garshya.com/ref/PRAJWAL123"
      );
      alert("Referral link copied!");
    }}
  >
    Copy
  </button>
</div>

<div className="refer-link-box-code">
  <input
    type="text"
    value="856458"
    readOnly
  />
  <button
    onClick={() => {
      navigator.clipboard.writeText(
        "https://garshya.com/ref/PRAJWAL123"
      );
      alert("Referral link copied!");
    }}
  >
    Copy
  </button>
</div>

{/* Actions */}
  <div className="refer-actions">
    <div className="action-box">
      <img
      src="/img/logo-whatsapp-png-46042.png"
      style={{width:"50px"}}
      />
      <span>Whatsapp</span>
    </div>
    <div className="action-box">
      <img
      src="/img/1083-removebg-preview.png"
      style={{width:"50px"}}
      />
      <span>Insatragm</span>
    </div>
    <div className="action-box">
      <img
      src="/img/vecteezy_telegram-logo-png-telegram-logo-transparent-png-telegram_23986679.png"
      style={{width:"50px"}}
      />
      <span>Telegram</span>
    </div>
  </div>
              {/* Details */}
              <div className="refer-details text-center">
              <h4>Details</h4>
              <p>
              Get 5 friends to subscribe, get the next 4 years of Hoppyn membership
              on us! You must be a subscriber to participate.
              </p>
              <p>
              Also, each registered friend you refer improves your waitlist priority.
              </p>
              </div>
              </div>
      </div>
    </div>
  );
};

export default ReferPage;
